import styled from '@emotion/styled';

import { DateRangeOption } from '../../models/dashboard/overview.model';

interface DateRangeSelectorProps {
  value: DateRangeOption;
  onChange: (range: DateRangeOption, startDate?: string, endDate?: string) => void;
  startDate?: string;
  endDate?: string;
}

const OPTIONS: { label: string; value: DateRangeOption }[] = [
  { label: 'Today', value: 'today' },
  { label: 'Last 7 days', value: '7d' },
  { label: 'Last 30 days', value: '30d' },
  { label: 'Custom', value: 'custom' },
];

const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({
  value,
  onChange,
  startDate,
  endDate,
}) => {
  return (
    <Container>
      <ButtonGroup>
        {OPTIONS.map((option) => (
          <RangeButton
            key={option.value}
            type='button'
            className={value === option.value ? 'active' : ''}
            onClick={() => onChange(option.value, startDate, endDate)}
          >
            {option.label}
          </RangeButton>
        ))}
      </ButtonGroup>

      {value === 'custom' && (
        <CustomDates>
          <DateInput
            type='date'
            value={startDate ?? ''}
            onChange={(e) => onChange('custom', e.target.value, endDate)}
          />
          <span>to</span>
          <DateInput
            type='date'
            value={endDate ?? ''}
            onChange={(e) => onChange('custom', startDate, e.target.value)}
          />
        </CustomDates>
      )}
    </Container>
  );
};

export default DateRangeSelector;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
`;

const ButtonGroup = styled.div`
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  border-radius: 10px;
  background: var(--sunk);
`;

const RangeButton = styled.button`
  border: none;
  background: transparent;
  padding: 5px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.grayTextColor};
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s ease;

  &:hover {
    color: ${({ theme }) => theme.palette.HetheraBlack};
  }

  &.active {
    background-color: #ffffff;
    color: ${({ theme }) => theme.palette.HetheraBlack};
    box-shadow: 0 1px 2px rgba(14, 26, 19, 0.1);
  }
`;

const CustomDates = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;

const DateInput = styled.input`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 13px;
  background: #ffffff;
  color: ${({ theme }) => theme.palette.HetheraBlack};
`;
